// USB / handheld QR scanner guns "type" the code very fast (a few ms per character), with or without Enter.
// This hook verifies automatically once such a burst ends, and keeps the box focused for the next scan.
import { useEffect, useRef } from "react";

export function useScannerInput(onScan, { minLength = 6 } = {}) {
  const ref = useRef(null);
  const st = useRef({ last: 0, fast: 0, timer: null });
  const cb = useRef(onScan);
  cb.current = onScan;

  useEffect(() => { const t = setTimeout(() => ref.current?.focus(), 200); return () => clearTimeout(t); }, []);

  const onKeyDown = (e) => {
    const s = st.current;
    if (e.key === "Enter") { clearTimeout(s.timer); s.fast = 0; cb.current(e.currentTarget.value); return; }
    if (e.key.length !== 1) return;
    const now = performance.now();
    s.fast = now - s.last < 45 ? s.fast + 1 : 0; // consecutive very fast keys = scanner
    s.last = now;
    clearTimeout(s.timer);
    s.timer = setTimeout(() => {
      const v = ref.current?.value || "";
      if (s.fast >= minLength - 2 && v.trim().length >= minLength) cb.current(v);
      s.fast = 0;
    }, 120);
  };
  const refocus = () => setTimeout(() => ref.current?.focus(), 50);
  return { ref, onKeyDown, refocus };
}
